import React from 'react';
import { message } from 'antd';
import {
  useCalendarActionPerformedState,
  useCalendarActionsData,
} from '../../../../services/calendarActionsProvider';
import { useFetchReportOnAcceptanceRecords } from '../../../../api/reportOnAcceptanceRecords';
import { useSearchParamsMethods } from '../../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { parseAcceptanceSlug } from '../../../../shared/packages/acceptance';
import { createUrlFromBase64 } from '../../../../../../helpers/attachments/createUrlFromBase64';
import { downloadAttachment } from '../../../../../../helpers/attachments/downloadAttachment';

const UploadAcceptanceRecords = () => {
  const { targetDate } = useCalendarActionsData();

  const { getParams } = useSearchParamsMethods();

  const [, setIsPerformed] = useCalendarActionPerformedState();

  const fetchReport = useFetchReportOnAcceptanceRecords();

  const handleClick = async () => {
    setIsPerformed(true);

    const { acceptanceId } = parseAcceptanceSlug(
      getParams(searchParamKeys.acceptance)
    );

    const result = await fetchReport({ acceptanceId, targetDate });

    setIsPerformed(false);

    if (result === 'Error') {
      return;
    }

    if (!result.success) {
      message.error(result.message ?? 'Не удалось загрузить записи на приемку');
      return;
    }

    const { data, fileName: title } = result.data;
    const { value: url, removeUrl } = createUrlFromBase64(data);
    downloadAttachment({ url, title });
    removeUrl();
  };

  return <div onClick={handleClick}>Выгрузить записи на приемку</div>;
};

export default UploadAcceptanceRecords;
